import { render, staticRenderFns } from "./pipl.vue?vue&type=template&id=588b7397&scoped=true"
import script from "./pipl.vue?vue&type=script&lang=js"
export * from "./pipl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b7397",
  null
  
)

export default component.exports